import firebase from "firebase";
import { Option } from "~/types/component";
import { Specialist } from "~/types/specialist";
import { Notification } from "~/types/notification";
import { Question } from "~/types/question";
import { Help } from "~/types/help";

type QuerySnapshot = firebase.firestore.QuerySnapshot<firebase.firestore.DocumentData>;

export const convertToOptions = (snapshot: QuerySnapshot) => {
  const options: Option[] = [];
  snapshot.forEach((doc) => {
    const data = doc.data();
    if ("name" in data && "code" in data) {
      const option: Option = {
        label: data.name,
        value: data.code,
      };
      options.push(option);
    }
  });
  return options;
};

export const convertToSpecialists = (snapshot: QuerySnapshot) => {
  const specialists: Specialist[] = [];
  snapshot.forEach((doc) => {
    const data = doc.data();

    // Timestamp -> Date
    if ("created" in data) {
      data.created = data.created.toDate();
    }

    const specialist = data as Specialist;
    specialists.push(specialist);
  });
  return specialists;
};

export const convertToNotifications = (snapshot: QuerySnapshot) => {
  const notifications: Notification[] = [];
  snapshot.forEach((doc) => {
    const data = doc.data();

    // ドキュメントIDをセット
    data.docID = doc.id;

    // Timestamp -> Date
    if ("created" in data) {
      data.created = data.created.toDate();
    }

    const notification = data as Notification;
    notifications.push(notification);
  });
  return notifications;
};

export const convertToHelps = (snapshot: QuerySnapshot) => {
  const helps: Help[] = [];
  snapshot.forEach((doc) => {
    const data = doc.data();

    // ドキュメントIDをセット
    data.docID = doc.id;

    // Timestamp -> Date
    if ("created" in data) {
      data.created = data.created.toDate();
    }

    const help = data as Help;
    helps.push(help);
  });
  return helps;
};

export const convertToQuestions = (snapshot: QuerySnapshot) => {
  const questions: Question[] = [];
  snapshot.forEach((doc) => {
    const data = doc.data();

    // ドキュメントIDをセット
    data.docID = doc.id;

    // Timestamp -> Date
    if ("created" in data) {
      data.created = data.created.toDate();
    }

    const question = data as Question;
    questions.push(question);
  });
  return questions;
};
